import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./InvestorSignupForm.css";
import { toast } from "react-toastify";

const InvestorSignupForm = ({ onClose }) => {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    amount: "",
    investment_type: "6 Weeks" // Default value
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const response = await fetch("https://rcsbackend.onrender.com/send-investor", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
  
      const result = await response.json();
  
      if (result.success) {
        toast.success("🎉 Investor sign-up request sent!");
        setFormData({
          full_name: "",
          email: "",
          phone: "",
          amount: "",
          investment_type: "6 Weeks",
        });
        onClose();
      } else {
        toast.error("❌ Failed to send investor request.");
      }
    } catch (err) {
      console.error("Server error:", err);
      toast.error("❌ Could not send message. Try again later.");
    }
  };
  

  return (
    <div className="modal-overlay">
<div className="modal-overlay investor-modal">
  <div className="modal-content">
    <h3>📥 Investor Sign-Up</h3>
        <form ref={formRef} onSubmit={handleSubmit}>
          <input
            name="full_name"
            type="text"
            placeholder="Full Name"
            value={formData.full_name}
            onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
            required
          />
          <input
            name="email"
            type="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            required
          />
          <input
            name="phone"
            type="tel"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            required
          />
          <input
            name="amount"
            type="number"
            placeholder="Estimated Investment Amount (GYD)"
            value={formData.amount}
            onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
            required
          />

          {/* 🆕 Investment Type Dropdown */}
          <select
            name="investment_type"
            value={formData.investment_type}
            onChange={(e) => setFormData({ ...formData, investment_type: e.target.value })}
            required
          >
            <option value="6 Weeks">6 Weeks</option>
            <option value="6 Months">6 Months</option>
            <option value="Annually">Annually</option>
          </select>

          <div className="button-row">
            <button type="submit">Submit</button>
            <button type="button" className="cancel-btn" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
    </div>
  );
};

export default InvestorSignupForm;
